<div *ngIf="isOnline" fxFlex>
  <mat-tab-group>
    <mat-tab label="Users">
      <div fxLayout="column">
        <div
          id="manage-all-users"
          fxLayout="column"
          fxLayoutAlign="space-between center"
        >
          <div
            fxLayout="column"
            id="unapproved-users"
            fxFlexFill
            fxLayoutAlign="start center"
          >
            <h1>Unapproved Users</h1>
            <manage-unapproved-users
              fxFlexFill
              [allUsers]="allUsers"
              (userApproved)="announceUserApproved($event)"
              (userDenied)="announceUserDenied($event)"
            ></manage-unapproved-users>
          </div>
          <mat-divider [inset]="true"></mat-divider>
          <h1>Registered Users</h1>
          <div fxLayout="row" id="manage-users" fxFlexFill>
            <div>
              <button mat-raised-button color="primary" (click)="onAddUser()">
                Add User
              </button>
            </div>
            <div fxFlex="5%"></div>
            <div fxLayout="row" fxFlex="20%">
              <mat-form-field class="user-search" fxFlexFill>
                <mat-label>Search</mat-label>
                <input
                  matInput
                  type="text"
                  [(ngModel)]="userSearchTerm"
                  (blur)="debounceFetchUsers(userSearchTerm)"
                  (input)="debounceFetchUsers(userSearchTerm)"
                />
                <button
                  *ngIf="userSearchTerm"
                  matSuffix
                  mat-icon-button
                  (click)="userSearchTerm = ''; searchData(userSearchTerm)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div fxFlex></div>
            <mat-paginator
              [length]="totalUsers"
              [pageSize]="limitPerPage"
              [hidePageSize]="true"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          </div>
        </div>
        <div fxLayout="column">
          <table
            matSort
            matSortActive="lastname"
            matSortDisableClear
            matSortDirection="asc"
            (matSortChange)="debounceSortData($event)"
            mat-table
            [dataSource]="dataSource"
          >
            <ng-container matColumnDef="uuid">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let user">
                {{ user.uuid | slice : 0 : 8 }}
              </td>
            </ng-container>

            <ng-container matColumnDef="avatar">
              <th mat-header-cell *matHeaderCellDef>Avatar</th>
              <td mat-cell *matCellDef="let user">
                <div>{{ user.hasProfilePic }}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="firstName">
              <th
                mat-header-cell
                mat-sort-header="firstname"
                disableClear
                *matHeaderCellDef
              >
                First Name
              </th>
              <td mat-cell *matCellDef="let user">{{ user.firstname }}</td>
            </ng-container>

            <ng-container matColumnDef="lastName">
              <th
                mat-header-cell
                mat-sort-header="lastname"
                disableClear
                *matHeaderCellDef
              >
                Last name
              </th>
              <td mat-cell *matCellDef="let user">{{ user.lastname }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th
                mat-header-cell
                mat-sort-header="email"
                disableClear
                *matHeaderCellDef
              >
                Email
              </th>
              <td mat-cell *matCellDef="let user">{{ user.email }}</td>
            </ng-container>

            <ng-container matColumnDef="rank">
              <th
                mat-header-cell
                mat-sort-header="rank"
                disableClear
                *matHeaderCellDef
              >
                Rank
              </th>
              <td mat-cell *matCellDef="let user">{{ user.rank }}</td>
            </ng-container>

            <ng-container matColumnDef="approved">
              <th
                mat-header-cell
                mat-sort-header="approved"
                disableClear
                *matHeaderCellDef
              >
                Approved
              </th>
              <td mat-cell *matCellDef="let user">
                <mat-icon *ngIf="user.email_domain_approved" color="primary"
                  >check</mat-icon
                >
                <mat-icon *ngIf="!user.email_domain_approved" color="warn"
                  >close</mat-icon
                >
              </td>
            </ng-container>

            <ng-container matColumnDef="verified">
              <th
                mat-header-cell
                mat-sort-header="confirmed"
                disableClear
                *matHeaderCellDef
              >
                Verified
              </th>
              <td mat-cell *matCellDef="let user">
                <mat-icon *ngIf="user.confirmed" color="primary"
                  >check</mat-icon
                >
                <mat-icon *ngIf="!user.confirmed" color="warn">close</mat-icon>
              </td>
            </ng-container>

            <ng-container matColumnDef="roles">
              <th mat-header-cell *matHeaderCellDef>Role(s)</th>
              <td mat-cell *matCellDef="let user">
                <mat-chip-list>
                  <mat-chip *ngFor="let role of user.roles">{{
                    role.name
                  }}</mat-chip>
                </mat-chip-list>
              </td>
            </ng-container>

            <ng-container matColumnDef="userMenu">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let user">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  aria-label="User Menu"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="onEditUser(user)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item (click)="onDeleteUser(user)">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <mat-paginator
            [length]="totalUsers"
            [pageSize]="limitPerPage"
            [hidePageSize]="true"
            (page)="onPageEvent($event)"
          >
          </mat-paginator>
          <div
            fxFlex
            fxLayout="row"
            fxLayoutAlign="center center"
            *ngIf="isLoading"
          >
            <mat-progress-spinner
              color="accent"
              mode="indeterminate"
              diameter="50"
            >
            </mat-progress-spinner>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngIf="canAccessRolePermManagement()" label="Roles"
      ><manage-roles></manage-roles
    ></mat-tab>
    <mat-tab *ngIf="canAccessRolePermManagement()" label="Permissions">
      <manage-permissions></manage-permissions>
    </mat-tab>
  </mat-tab-group>
  <div *ngIf="!isOnline" fxLayout="column">
    <div fxFlexFill>
      This service is unavailable in offline mode. Please try again when your
      device is back online.
    </div>
  </div>
</div>
